import { render, staticRenderFns } from "./Subtitles.vue?vue&type=template&id=984135e0&scoped=true&"
import script from "./Subtitles.vue?vue&type=script&lang=js&"
export * from "./Subtitles.vue?vue&type=script&lang=js&"
import style0 from "./Subtitles.vue?vue&type=style&index=0&id=984135e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984135e0",
  null
  
)

export default component.exports